var _path, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResourcesIcon = function SvgResourcesIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C4 5.44771 4.44772 5 5 5H8.63875C9.24632 5 9.81762 5.27945 10.2462 5.71013C10.8596 6.32663 11.8298 7.15746 12.8 7.4L12.8003 7.4001H19C19.5523 7.4001 20 7.84781 20 8.4001V16.2H4V7.4001H4.04549L4 7.4V6ZM4 17H20V17.6001C20 18.1524 19.5523 18.6001 19 18.6001H5C4.44772 18.6001 4 18.1524 4 17.6001V17ZM6 7.4C6.22091 7.4 6.4 7.57909 6.4 7.8V12.6C6.4 12.8209 6.22091 13 6 13C5.77909 13 5.6 12.8209 5.6 12.6V7.8C5.6 7.57909 5.77909 7.4 6 7.4ZM6 13.8C6.22091 13.8 6.4 13.9791 6.4 14.2V15C6.4 15.2209 6.22091 15.4 6 15.4C5.77909 15.4 5.6 15.2209 5.6 15V14.2C5.6 13.9791 5.77909 13.8 6 13.8Z",
    fill: "url(#paint0_linear_2642_70781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2642_70781",
    x1: 4,
    y1: 11.041,
    x2: 19.8252,
    y2: 11.0406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3864FF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourcesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Resources-Icon.e3e01c6a.svg";
export { ForwardRef as ReactComponent };